import { NgModule } from '@angular/core';

// Components
import { FileUploadButtonComponent } from './components/file-upload-button/file-upload-button.component';
import { FileUploadDropZoneComponent } from './components/file-upload-drop-zone/file-upload-drop-zone.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { FileUploadItemComponent } from './components/file-upload-item/file-upload-item.component';
import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';
import { ImageViewComponent } from './components/image-view/image-view.component';
import { FileDownloaderComponent } from './components/file-downloader/file-downloader.component';
import { FileEditorComponent } from './components/file-editor/file-editor.component';
import { FileUpdaterComponent } from './components/file-updater/file-updater.component';
import { FilesListViewComponent } from './components/files-list-view/files-list-view.component';
import { FilesFolderViewComponent } from './components/files-folder-view/files-folder-view.component';
import { FolderComponent } from './components/files-folder-view/folder/folder.component';
import { UploadStorageUsageComponent } from './components/upload-storage-usage/upload-storage-usage.component';

const COMPONENTS = [
  FileUploadButtonComponent,
  FileUploadDropZoneComponent,
  FileUploaderComponent,
  FileUploadItemComponent,
  ImageUploaderComponent,
  ImageViewComponent,
  FileDownloaderComponent,
  FileEditorComponent,
  FileUpdaterComponent,
  FilesListViewComponent,
  FilesFolderViewComponent,
  FolderComponent,
  UploadStorageUsageComponent
];

@NgModule({
  imports: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class XmedicalUploadsModule {}
